import { useQuery } from "react-query";
import { fetchTeamVelocity, ITeamVelocitySummary } from "../api/aiMetricsApi";
import { ADO_QUERY_KEYS, adoPriorQueryKey } from "./adoQueryKeys";

const STALE_TIME = 5 * 60 * 1000;

export const useTeamVelocity = (
  teams: string[],
  startDate: Date,
  endDate: Date,
  priorStartDate: Date,
  priorEndDate: Date,
  comparisonEnabled = true,
  sprints: string[] = [],
) => {
  const sortedTeams = JSON.stringify([...teams].sort());
  const sortedSprints = JSON.stringify([...sprints].sort());

  const current = useQuery<ITeamVelocitySummary, Error>(
    [
      ADO_QUERY_KEYS.teamVelocity,
      sortedTeams,
      startDate.toISOString(),
      endDate.toISOString(),
      sortedSprints,
    ],
    () => fetchTeamVelocity(teams, startDate, endDate, sprints),
    { staleTime: STALE_TIME, enabled: teams.length > 0 },
  );

  const prior = useQuery<ITeamVelocitySummary, Error>(
    [
      adoPriorQueryKey(ADO_QUERY_KEYS.teamVelocity),
      sortedTeams,
      priorStartDate.toISOString(),
      priorEndDate.toISOString(),
      sortedSprints,
    ],
    () => fetchTeamVelocity(teams, priorStartDate, priorEndDate, sprints),
    {
      staleTime: STALE_TIME,
      enabled: comparisonEnabled && teams.length > 0,
    },
  );

  return { current, prior };
};
